'use strict';

/**
 * Contentiframe
 *
 * Makes iFrame responsive, using a plugin/lib to apply height of iFrame depneding on its content.
 * Additionally: Adding Viewport-CSS-classes to iFrame <body>, but not impelmented.
 *
 * Next steps if we really use this iFrame for integration:
 * Chose a lib that supports applying class to iFrame body (via  Web Messaging API),
 *   the only way to doing it because of Same-origin security policy (CORS won't solve).
 *
 * @author Mathias Hayoz <mathias.hayoz@namics.com>
 */
T.Module.Contentiframe = T.createModule({

	_selectors: {
		iframe: '[data-js-m-contentiframe__iframe]'
	},

	_stateClasses: {
		viewportPrefix: 'vp-'
	},

	start: function start(resolve) {
		this.$ctx = $(this._ctx);

		// References
		this.$iframe = this.$ctx.find(this._selectors.iframe);

		// Global Event Binding
		this._events.on('viewport.match', this.onViewportMatch.bind(this));
		this._events.on('viewport.unmatch', this.onViewportUnmatch.bind(this));

		// Component Event Binding
		this.$iframe.on('load', this.$oniFrameLoad.bind(this));

		// Data
		this.vpClasses = new Map();
		this.isIframeLoaded = false;

		// Init
		this.initIframe();

		resolve();
	},
	onViewportMatch: function onViewportMatch(vpName) {
		if (this.isViewPortNameInList(vpName)) {
			this.addVpClass(this.getViewPortClassFromName(vpName));
			this.updateIframeClasses();
		}
	},
	onViewportUnmatch: function onViewportUnmatch(vpName) {
		if (this.isViewPortNameInList(vpName)) {
			this.removeVpClass(this.getViewPortClassFromName(vpName));
			this.updateIframeClasses();
		}
	},


	/**
  * Event when the iframe has finished loading
  *
  * @returns {undefined} void
  */
	$oniFrameLoad: function $oniFrameLoad() {
		this.isIframeLoaded = true;
		this.updateIframeClasses();
	},


	/**
  * Initialize the iframe plugin
  *
  * @returns {undefined} void
  */
	initIframe: function initIframe() {
		if (!$.fn.iFrameResize) {
			return;
		}

		var pluginOptions = {};

		this.$iframe.iFrameResize(pluginOptions);
	},


	/**
  * Add Viewport Classe to inner iFrame, so iFrame is able to be responsive, without defining own media-queries.
  *
  * @param {string} viewPortName - Viewport name as defined in global viewport definition.
  * @returns {undefined} void
  */
	addVpClass: function addVpClass(viewPortName) {
		this.vpClasses.set(viewPortName, true);
	},


	/**
  * Removes Viewport Class from inner iFrame
  *
  * @see addVpClass
  * @param {string} viewPortName - Viewport name as defined in global viewport definition.
  * @returns {undefined} void
  */
	removeVpClass: function removeVpClass(viewPortName) {
		this.vpClasses.set(viewPortName, false);
	},


	/**
  * Updates classes applied to iFrame
  *
  * @returns {undefined} void
  */
	updateIframeClasses: function updateIframeClasses() {
		var _this = this;

		if (this.isIframeLoaded !== true) {
			return;
		}

		if (this.$iframe[0].iFrameResizer) {
			this.vpClasses.forEach(function (flag, vpClass) {
				if (flag === true && vpClass) {
					_this.$iframe[0].iFrameResizer.sendMessage({ actionType: 'addBodyClass', value: vpClass });
				} else {
					_this.$iframe[0].iFrameResizer.sendMessage({ actionType: 'removeBodyClass', value: vpClass });
				}
			});
		}
	},


	/**
  * Returns true if viewport name (from event) is in this specific whitelist.
  *
  * @param {string} viewPortName - Viewport name as defined in global viewport definition.
  * @returns {boolean} void
  */
	isViewPortNameInList: function isViewPortNameInList(viewPortName) {
		var isInList = false;

		// Whiteliste VP-Names
		var whitelist = {
			'phone-down': true,
			'small-up': true,
			'medium-up': true,
			'large-up': true,
			'xlarge-up': true
		};
		if ({}.hasOwnProperty.call(whitelist, viewPortName) && whitelist[viewPortName] === true) {
			isInList = true;
		}

		return isInList;
	},


	/**
  * Returns a viewport class for the provided viewport name
  *
  * @param {string} viewPortName - Viewport name as defined in global viewport definition.
  * @returns {string} The viewport Class
  */
	getViewPortClassFromName: function getViewPortClassFromName(viewPortName) {
		return '' + this._stateClasses.viewportPrefix + viewPortName;
	}
});